// src/config/firestore-collections.js

// Definición de colecciones - Única fuente de verdad
// Se usan los nombres con sufijo _dev como nombres definitivos según requerimiento del usuario.
export const COLLECTION_NAMES = {
  // Talento Humano
  personalVarios: "PersonalVarios_Dev",
  attendance_logs: "attendance_logs",

  // Sistema / Admin
  users: "users_dev",
  permissions: "permissions_dev",
  roles: "roles_dev",

  // Gestión de Asistencia
  holidays: "holidays_dev",
  absenceJustifications: "absence_justifications_dev",

  // Activos
  assignedAssets: "assigned_assets_dev",

  // Planillas y Boletas
  planillasGeneradas: "planillas_generadas_dev",
  variablesMensuales: "variables_mensuales_dev",
  configuracionEmpleadoPlanilla: "configuracion_empleado_planilla_dev",
  descuentosPersonal: "descuentos_personal_dev"
};
